import { memo } from 'react';
import { styled } from '@mui/material/styles';
import { Container, AppBar } from '@mui/material';

import { HEADER } from 'config';
import { NavSectionHorizontal } from 'components/nav-section';
import { useUser } from 'queries/Users';
import { useFacilityById } from 'queries/Facility';
import checkAccess from 'utils/roles/checkAccess';
import navConfig from './NavConfig';

const RootStyle = styled(AppBar)(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

function NavbarHorizontal() {
  const { role, facilityId, isInitialLoading: isLoadingUser } = useUser();
  const { data, isInitialLoading: isLoadingFacility } = useFacilityById({
    facilityId,
    settings: { enabled: !!facilityId && checkAccess([3]) },
  });

  const isLoading = isLoadingUser || isLoadingFacility;
  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal
          isLoading={isLoading}
          navConfig={navConfig({ role, facilityType: data?.classification || null })}
        />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
